import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { Router } from '@angular/router';
import { CampaignId } from '../../module/campaign-util/shared/campaign-id';
import { SessionManager } from '../../session/service/session-manager';
import { SessionTokenService } from '../../session/service/session-token';
import { HttpCacheClient } from '../../shared/http/cache-client';

@Component({
  selector: 'sidebar',
  templateUrl: 'sidebar.component.html',
  styleUrls: [ 'sidebar.component.scss' ],
  animations: [
    trigger('toggleHeight', [
      state('inactive', style({
        height: '0',
        opacity: '0'
      })),
      state('active', style({
        height: '*',
        opacity: '1'
      })),
      transition('inactive <=> active', [
        animate('250ms ease-out')
      ])
    ])
  ]
})
export class SidebarComponent implements OnInit, AfterViewInit {

  identity: any;
  selectedItem: string;
  user: any = {};
  license: any = null;

  @ViewChild('listNavigation', { static: false })
  listNavigation;

  constructor(protected campaignId: CampaignId,
              private router: Router,
              private httpCacheClient: HttpCacheClient,
              private sessionManager: SessionManager,
              private sessionToken: SessionTokenService) {
  }

  ngOnInit() {
    this.sessionManager.getIdentity()
      .subscribe(response => {
        this.user = response;
        if (response && response.customer ) {
          this.license = response.customer.customerLicense;
        }
      });
  }

  ngAfterViewInit() {
  }

  backToAdmin() {
    this.campaignId.release();
    this.sessionToken.persist(this.sessionToken.getAdminToken());
    this.sessionToken.destroyAdminToken();
    this.router.navigate([ '/admin/accounts' ]);
  }

  onListElementClick(event: Event, element: HTMLElement) {
    event.preventDefault();
    for (const child of this.listNavigation.nativeElement.children) {
      child.classList.remove('active');
    }
    if (element.classList.contains('active')) {
      element.classList.remove('active');
    } else {
      element.classList.add('active');
    }
  }

  get url(): string {
    return this.router.url;
  }

  excludeRoles(roles: string[]): boolean {
    return this.user ? roles.indexOf(this.user.role) === -1 : false;
  }
}
